import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button'


export class DashboardRomDocuments extends Component {

    render() {

        const { eRomHandbook, oRomHandbook, eInGuideline, oInGuideline } = this.props

        return (
            <Card>
                <CardHeader title="ROM Guiding Documents" className='romis-card-header' />
                <CardContent>

                    <Grid container spacing={6} >
                        <Grid xs={4} item>
                            <Typography variant="h6" gutterBottom>
                                ROM Handbook
                            </Typography>
                        </Grid >
                        <Grid item xs={4}>

                            <Button variant="outlined" color="primary" fullWidth
                                href={oRomHandbook}
                                download="HandbookOngoing.pdf">
                                Ongoing
                            </Button>
                        </Grid>
                        <Grid item xs={4}>
                            <Button variant="outlined" color="primary" fullWidth
                                href={eRomHandbook}
                                download="HandbookExpost.pdf">
                                Ex-Post
                            </Button>
                        </Grid>


                    </Grid>
                    <Grid container className="mt-1" spacing={6} >
                        <Grid xs={4} item>
                            <Typography variant="h6" gutterBottom>
                                ROM Guidelines
                            </Typography>
                        </Grid >
                        <Grid item xs={4}>

                            <Button variant="outlined" color="primary" fullWidth
                                href={oInGuideline}
                                download="GuidelinesOngoing.docx">
                                Ongoing
                            </Button>
                        </Grid>
                        <Grid item xs={4}>
                            <Button variant="outlined" color="primary" fullWidth
                                href={eInGuideline}
                                download="GuidelinesExpost.docx">
                                Ex-Post
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/DashboardRomDocuments.js